import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";

import heroSectionBg from "../../images/v4/whatsappAiChatbot/images/heroSectionBg.png";
import accordianTabsBg from "../../images/v4/whatsappAiChatbot/images/accordianTabsBg.png";
import benefitsBg from "../../images/v4/whatsappAiChatbot/images/benefitsBg.png";
import realWorldBg from "../../images/v4/whatsappAiChatbot/images/realWorldBg.png";

import cardImg1 from "../../images/v4/whatsappAiChatbot/images/cardImg1.webp";
import cardImg2 from "../../images/v4/whatsappAiChatbot/images/cardImg2.webp";

import bannerIcon1 from "../../images/v4/whatsappAiChatbot/icons/bannerIcon1.svg";
import bannerIcon2 from "../../images/v4/whatsappAiChatbot/icons/bannerIcon2.svg";
import bannerIcon3 from "../../images/v4/whatsappAiChatbot/icons/bannerIcon3.svg";
import bannerIcon4 from "../../images/v4/whatsappAiChatbot/icons/bannerIcon4.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import experienceImg1 from "../../images/v4/whatsappAiChatbot/images/experienceImg1.webp";
import experienceImg2 from "../../images/v4/whatsappAiChatbot/images/experienceImg2.webp";
import experienceImg3 from "../../images/v4/whatsappAiChatbot/images/experienceImg3.webp";
import experienceImg4 from "../../images/v4/whatsappAiChatbot/images/experienceImg4.webp";
import experienceImg5 from "../../images/v4/whatsappAiChatbot/images/experienceImg5.webp";
import experienceImg6 from "../../images/v4/whatsappAiChatbot/images/experienceImg6.webp";

import realWorldImage1 from "../../images/v4/whatsappAiChatbot/images/realWorldImage1.webp";
import realWorldImage2 from "../../images/v4/whatsappAiChatbot/images/realWorldImage2.webp";
import realWorldImage3 from "../../images/v4/whatsappAiChatbot/images/realWorldImage3.webp";
import realWorldImage4 from "../../images/v4/whatsappAiChatbot/images/realWorldImage4.webp";
import realWorldImage5 from "../../images/v4/whatsappAiChatbot/images/realWorldImage5.webp";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/whatsappAiChatbot/images/compareItemImg5.webp";

import salesImg1 from "../../images/v4/whatsappAiChatbot/icons/salesImg1.svg";
import salesImg2 from "../../images/v4/whatsappAiChatbot/icons/salesImg2.svg";
import salesImg3 from "../../images/v4/whatsappAiChatbot/icons/salesImg3.svg";
import salesImg4 from "../../images/v4/whatsappAiChatbot/icons/salesImg4.svg";
import salesImg5 from "../../images/v4/whatsappAiChatbot/icons/salesImg5.svg";
import salesImg6 from "../../images/v4/whatsappAiChatbot/icons/salesImg6.svg";
import salesImg7 from "../../images/v4/whatsappAiChatbot/icons/salesImg7.svg";

import bannerTick from "../../images/v4/salesReps/heroTick.svg";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

const useStyles = makeStyles((theme) => ({
  SalesMangerSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${heroSectionBg})`,
    padding: "60px 0 0",
    backgroundPosition: "top",
    overflow: "hidden",
    "@media only screen and (max-width: 1024px)": {
      maxHeight: "100%",
      minHeight: "100%",
      "& .container": {
        height: "auto",
      },
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },

    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  SalesMangerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
  heroContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "32px",
    textAlign: "center",
    margin: "0 auto 64px",
    maxWidth: "1200px",
    "& p": {
      maxWidth: "1000px",
      marginBottom: "8px",
    },
    "@media(max-width:1024px)": {
      "& h1": {
        margin: "0",
      },
    },
  },
  bannerCards: {
    display: "flex",
    alignItems: "flex-start",
    gap: "24px",
    flexWrap: "nowrap", // default unless overridden below
    "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
      transform: "translateY(25px) !important",
    },
    "@media (max-width:1024px)": {
      flexWrap: "wrap",
      alignItems: "stretch",
      "& .bannerCard:nth-of-type(1), & .bannerCard:nth-of-type(4)": {
        transform: "translateY(0) !important",
      },
    },
    "@media(max-width:768px)": {
      gap: "15px",
    },
  },
  cardContainer: {
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "18px",
    padding: "25px",
    background: "rgba(0, 44, 81, 0.4)",
    backdropFilter: "blur(20px)",
    height: "320px",
    position: "relative",
    overflow: "hidden",
    "&.greenCard": {
      background: "#014957",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #028BA6 60%, #014957 100%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard": {
      background: "#41086E",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 30%, #B458FF 50%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard": {
      background: "#026f85",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background:
            "radial-gradient(circle,rgb(5, 182, 217) 80%, #026f85 100%)",
          borderRadius: "50%",
          filter: "blur(80px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard": {
      background: "rgb(0, 45, 81)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "@media(max-width:1024px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
      },
    },
    "@media(max-width:992px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:600px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "48%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:400px)": {
      padding: "16px",
      gap: "8px",
      "&.bannerCard": {
        width: "47%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
  },
  Client: {
    position: "relative",
    zIndex: "10",
    "& .container": {
      paddingTop: "0",
      "@media(max-width:1024px)": {
        padding: "65px 25px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "30px",
          },
        },
      },
      "@media(max-width:768px)": {
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "25px",
          },
        },
      },

      "@media(max-width:600px)": {
        padding: "40px 15px",
        "& .client-logo": {
          "& img": {
            width: "auto",
            height: "20px",
          },
        },
      },
    },
    "& p": {
      textAlign: "center",
      marginBottom: "32px",
    },
    "& .client-logo": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "30px",
      },
    },
  },
  integrationSection: {},
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& $integrationLeft": {
      flexDirection: "column",
      gap: "32px",
      alignItems: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      display: "flex",
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& $integrationRight": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      color: "#1D6FB6",
      gap: "10px",
      "@media only screen and (max-width: 768px)": {
        marginBottom: "15px",
      },
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
    "& .exp-desc": {
      margin: "10px 0",
    },
  },

  accordianTabs: {
    backgroundSize: "cover",
    backgroundImage: `url(${accordianTabsBg})`,
    padding: "60px 0 0",
    backgroundPosition: "top",
    paddingTop: "240px",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "330px",
    },

    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      "& h2": {
        width: "80%",
      },
      "& p": {
        width: "40%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "18px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    padding: "15px 0",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  faqBoxAccordian: {
    padding: "24px",
    backgroundColor: "#f8fcff",
    borderRadius: "16px",
    cursor: "pointer",
    "&.active": {
      backgroundImage: " linear-gradient(89deg, #e0effd 4%, #e0fafa 100%)",
    },
    "@media(max-width:768px)": {
      padding: "16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    "&.noClick": {
      cursor: "not-allowed",
    },
    "& h3": {
      margin: "0",
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& .container": {
      padding: "0 0 120px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        width: "100%",
        "& h2": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "250px 15px 65px",
      "& .container": {
        padding: "0 15px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "180px 15px 40px",
      "& .container": {
        padding: "0",
      },
      "& .centerContainer": {
        "& h2": {
          width: "100% !important",
        },
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    minWidth: "max-content",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    width: "50%",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "45%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px !important",
    "& img": {
      width: "100%",
      marginTop: "8px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px !important",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    zIndex: "1",
    "& .container": {
      paddingTop: "0",
    },
    "@media only screen and (max-width: 768px)": {},
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #7C35B5 0%, #672A99 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  benifitSection: {
    position: "relative",
    paddingBottom: "300px",
    "& $absoulteCard": {
      position: "absolute",
      margin: "0 auto",
      width: "100%",
      top: "100%",
      transform: "translate(-50% ,-50%)",
      left: "50%",
      right: "0",
      "& $integrationHeader": {
        background: "linear-gradient(90deg, #015352 0%, #00926A 100%)",
        borderRadius: "32px",
        padding: "40px",
      },
      "& $integrationRight": {
        width: "40%",
      },
      "& .container": {
        paddingTop: "0",
      },
      "@media only screen and (max-width: 768px)": {
        "& $integrationHeader": {
          padding: "20px",
          borderRadius: "16px",
        },
        "& $integrationRight": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "350px",
    },
  },
  salesCrmCarousel: {
    position: "relative",
    backgroundImage: `url(${benefitsBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "380px",
    "& .header-section": {
      flexDirection: "column",
      width: "55%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
        "& h2": {
          marginBottom: "0",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "380px",
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "350px",
      "& .header": {
        width: "80%",
      },
      "& h2": {
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "210px",
      "& .header": {
        width: "100%",
      },
      "& h2": {
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingBottom: "220px",
      "& h2": {
        marginBottom: "0",
      },
    },
  },
  adaptSlider: {
    padding: "20px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "20px 0",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  adaptsBox: {
    gap: "24px",
    display: "flex!important",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    height: "auto!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "20px",
      maxWidth: "350px",
      gap: "14px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "18px",
      maxWidth: "320px",
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "12px",
      maxWidth: "85%",
      gap: "10px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 1024px)": {
      minHeight: "70px",
    },
    "@media only screen and (max-width: 768px)": {
      minHeight: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
      minHeight: "auto",
    },
    "@media only screen and (max-width: 480px)": {
      minHeight: "auto",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
    "@media only screen and (max-width: 1024px)": {
      width: "44px",
      maxWidth: "44px",
      marginBottom: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "40px",
      maxWidth: "40px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "36px",
      maxWidth: "36px",
      marginBottom: "16px",
    },
    "@media only screen and (max-width: 480px)": {
      width: "32px",
      maxWidth: "32px",
      marginBottom: "14px",
    },
  },
  testimonials: {
    background: "#F8FCFF",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
}));

const aiWhatsappChatbot = () => {
  const classes = useStyles();
  const sectionRef = useRef(null);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(`.${classes.cardContainer}:first-child`),
      document.querySelector(`.${classes.cardContainer}.blueCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.regularCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.purpleCard`),
      ...document.querySelectorAll(`.${classes.cardContainer}.greenCard`), // Add regularCards
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);
  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];

  const benifitList = [
    {
      img: cardImg1,
      title: "Your 24/7 assistant: Instant answers, zero wait!",
      points: [
        {
          heading: "Customisable topics and flows",
          content:
            "Tailor conversation paths to match your business needs, ensuring the chatbot addresses specific customer enquiries effectively.",
        },
        {
          heading: "Smart handoff to human agents",
          content:
            "Seamlessly transfer complex queries to human agents, providing a smooth transition and guaranteeing superior customer support.",
        },
        {
          heading: "Customisable appearance",
          content:
            "Align your chatbot with your brand by personalising its name, icon, and welcome message for a cohesive customer experience.",
        },
      ],
    },
  ];
  const faqs = [
    {
      question: "What makes Pepper Cloud the best WhatsApp chatbot solution?",
      answer: (
        <>
          Pepper Cloud offers advanced AI capabilities, a user-friendly
          interface, and seamless integration with WhatsApp, along with features
          like codeless chatbot building and omnichannel deployment.
        </>
      ),
    },
    {
      question:
        "Can I create a WhatsApp chatbot without coding skills using Pepper Cloud?",
      answer: (
        <>
          Yes, Pepper Cloud provides a codeless drag-and-drop chatbot builder,
          allowing you to create sophisticated chatbots without any programming
          knowledge.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud WhatsApp chatbot handle complex customer queries?",
      answer: (
        <>
          Pepper Cloud's chatbot uses advanced natural language processing to
          understand and respond to a wide range of queries. For complex issues,
          it can seamlessly hand over to human agents.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud ensure the security of WhatsApp conversations?",
      answer: (
        <>
          Pepper Cloud adheres to strict security protocols and data protection
          regulations to ensure the confidentiality and integrity of all
          WhatsApp conversations.
        </>
      ),
    },
    {
      question:
        "Can I customise the chatbot's responses to match my brand voice?",
      answer: (
        <>
          Absolutely. Pepper Cloud allows you to fully customise your chatbot's
          responses to align with your brand personality and tone.
        </>
      ),
    },
    {
      question:
        "What are the best practices for designing an effective WhatsApp chatbot?",
      answer: (
        <>
          <ul>
            <li>Keep chatbot flows simple and clear.</li>
            <li>Personalize responses using customer data.</li>
            <li>Provide easy opt-out options for users.</li>
            <li>Maintain your brand’s tone and language.</li>
            <li>Regularly update the chatbot’s content.</li>
            <li>Use progressive profiling to collect user data gradually.</li>
            <li>Incorporate rich media like images, videos, and buttons.</li>
            <li>Enable seamless handover to human agents when needed.</li>
            <li>Continuously analyze performance and user feedback.</li>
            <li>Respect user privacy and follow data protection laws.</li>
          </ul>
        </>
      ),
    },
    {
      question: "How often should I update my chatbot's knowledge base?",
      answer: (
        <>
          It's recommended to review and update your chatbot's knowledge base
          regularly, ideally on a monthly basis or whenever there are
          significant changes in your products, services, or policies.
        </>
      ),
    },
    {
      question:
        "Can I schedule messages or campaigns using Pepper Cloud's WhatsApp chatbot?",
      answer: (
        <>
          Yes, Pepper Cloud provides features for scheduling messages and
          managing marketing campaigns through WhatsApp.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud's WhatsApp chatbot handle customer feedback?",
      answer: (
        <>
          The chatbot can be programmed to collect customer feedback through
          surveys or rating systems, providing valuable insights for your
          business.
        </>
      ),
    },
    {
      question:
        "How quickly can I set up a WhatsApp chatbot using Pepper Cloud?",
      answer: (
        <>
          With Pepper Cloud's user-friendly interface, you can set up a basic
          WhatsApp chatbot in just a few hours, depending on your specific
          requirements.
        </>
      ),
    },
    {
      question:
        "Does Pepper Cloud provide training on how to use its WhatsApp chatbot features?",
      answer: (
        <>
          Yes, Pepper Cloud offers comprehensive training resources, including
          tutorials, webinars, and customer support to help you make the most of
          its features.
        </>
      ),
    },
    {
      question:
        "How does the Pepper Cloud WhatsApp chatbot work and how do I set it up?",
      answer: (
        <>
          Pepper Cloud’s WhatsApp chatbot, powered by AssistAI, helps automate
          customer interactions directly from your CRM. Here’s how it works and
          how to set it up:
          <ol>
            <li>
              <strong>Access AssistAI Chatbot:</strong> Log in to your CRM → Go
              to Settings → Automation → AssistAI Chatbot → Click “+” to start
              creating a chatbot.
            </li>
            <li>
              <strong>Configure Basic Settings:</strong> Give your chatbot a
              name and a short description to define its purpose.
            </li>
            <li>
              <strong>Add Topics:</strong> Use system-generated topics from the
              Overview or Topics tab, or create your own topics to define custom
              conversation flows.
            </li>
            <li>
              <strong>Integrate Channels:</strong> Go to the Channels tab →
              Select “WhatsApp” as the channel → Click “Connect channel”.
            </li>
            <li>
              <strong>Customise Configuration:</strong> In the Configuration
              tab, set up a fallback message and define when it should trigger.
            </li>
            <li>
              <strong>Publish Your Chatbot:</strong> Once the setup is complete,
              click “Publish” to activate your WhatsApp chatbot.
            </li>
          </ol>
          This integration enables seamless automated communication on WhatsApp
          while managing everything from within Pepper Cloud CRM.
        </>
      ),
    },
  ];
  const AUTO_PLAY_INTERVAL = 10000;

  const experienceList = [
    {
      title: "Self-service AI with a human touch",
      alt: "Efficient best solution for WhatsApp chatbot",
      img: experienceImg1,
      desc: "Pepper Cloud's WhatsApp chatbot combines advanced AI with a personable approach, ensuring customers receive accurate, context-aware responses that feel natural and engaging.",
    },
    {
      title: "No code chatbot builder",
      alt: "Intuitive WhatsApp chatbot customer support",
      img: experienceImg2,
      desc: "Create sophisticated chatbots without any coding knowledge using our intuitive drag-and-drop interface. Empower your team to design and deploy custom chatbot flows effortlessly.",
    },
    {
      title: "Seamless omnichannel integration",
      alt: "Advanced best WhatsApp chatbot features",
      img: experienceImg3,
      desc: "Pepper Cloud CRM enables seamless integration across multiple channels—email, social media, website forms, and messaging apps—capturing all leads in one unified system. Your sales team can access real-time customer interactions, improving communication and follow-up efficiency.",
    },
    {
      title: "Advanced natural language processing",
      alt: "WhatsApp chatbot for instant communication",
      img: experienceImg4,
      desc: "Our chatbot understands and responds to a wide range of customer queries in natural language, ensuring smooth and effective communication.",
    },
    {
      title: "Customisable knowledge base",
      alt: "Best solution automates WhatsApp chatbot queries",
      img: experienceImg5,
      desc: "Easily update and expand your chatbot's knowledge base to keep information current and relevant. Improve response accuracy and customer satisfaction at every touchpoint.",
    },
    {
      title: "Real-time analytics and insights",
      alt: "WhatsApp chatbot simplifies help desk tasks",
      img: experienceImg6,
      desc: "Gain valuable insights into customer interactions, preferences, and pain points with comprehensive analytics. Continually optimise your chatbot’s performance for better results.",
    },
  ];
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });
  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  // When user clicks on an accordion
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    setUserSelected(true);

    // Restart autoplay so the full interval is shown after click
    // Without resetting to the next immediately
    clearInterval(intervalId);
    intervalId = setInterval(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.blueCard`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);
  //card height
  useEffect(() => {
    const updateCardHeights = () => {
      const cards = document.querySelectorAll(".bannerCard");

      cards.forEach((card) => {
        if (window.innerWidth <= 1024) {
          card.style.height = "auto"; // let it size naturally
        } else {
          const originalHeight = card.offsetHeight;
          card.style.height = `${originalHeight}px`; // add 100px
        }
      });
    };

    // Run on mount
    updateCardHeights();

    // Run on resize
    window.addEventListener("resize", updateCardHeights);
    return () => window.removeEventListener("resize", updateCardHeights);
  }, []);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Product recommendations based on customer preferences",
          content:
            "Tailored suggestions that align with individual tastes, enhancing the shopping experience and encouraging purchases.",
          alt: "Personalised product recommendations",
        },
        {
          heading: "Order tracking and updates",
          content:
            "Real-time notifications on order status, ensuring customers remain informed about their purchases from dispatch to delivery.",
          alt: "Order status tracking and notifications",
        },
        {
          heading: "Abandoned cart recovery",
          content:
            "Strategic reminders and incentives to encourage customers to complete their purchases after leaving items in their online shopping basket.",
          alt: "Cart abandonment recovery",
        },
      ],
      image: realWorldImage1,
      alt: "Reliable best WhatsApp chatbot platform",
      subtitle:
        "Enhance customer shopping experience and boost sales through personalised interactions.",
    },
    {
      tabContent: [
        {
          heading: "Appointment scheduling",
          content:
            "Easily organise your medical appointments and receive reminders to ensure you stay on track.",
          alt: "Medical appointment scheduling and reminders",
        },
        {
          heading: "Medication reminders",
          content:
            "Get timely notifications for your medications to help maintain adherence to your health regimen.",
          alt: "Medication timing reminders",
        },
        {
          heading: "Health tips",
          content:
            "Access valuable health tips and wellness advice to support your overall well-being and lifestyle choices.",
          alt: "Daily health and wellness tips",
        },
      ],
      image: realWorldImage2,
      alt: "WhatsApp chatbot enhances sales support",
      subtitle: "Improve patient care and streamline healthcare services.",
    },
    {
      tabContent: [
        {
          heading: "Booking assistance and confirmations",
          content:
            "Help with securing reservations and providing timely confirmations for your travel arrangements.",
          alt: "Travel booking support and confirmation",
        },
        {
          heading: "Travel itinerary management",
          content:
            "Support in creating and organising your travel schedule to ensure a seamless experience.",
          alt: "Itinerary planning and management",
        },
        {
          heading: "Local recommendations and concierge services",
          content:
            "Guidance on the best local attractions, dining options, and personal assistance for a more enjoyable visit.",
          alt: "Concierge and local recommendation services",
        },
      ],
      image: realWorldImage3,
      alt: "Top-rated best solution for WhatsApp chatbot",
      subtitle:
        "Provide seamless travel experiences and increase customer satisfaction.",
    },
    {
      tabContent: [
        {
          heading: "Account balance enquiries",
          content:
            "Get quick updates on your current account balance and review your transaction history for better financial awareness.",
          alt: "Check account balances and transactions",
        },
        {
          heading: "Bill payment reminders",
          content:
            "Stay organised with reminders for upcoming bills and easily process payments to avoid late fees.",
          alt: "Bill reminders and payments",
        },
        {
          heading: "Investment advice",
          content:
            "Receive tailored investment guidance and manage your portfolio effectively to meet your financial goals.",
          alt: "Personalised investment consulting",
        },
      ],
      image: realWorldImage4,
      alt: "Best WhatsApp chatbot enables quick answers",
      subtitle: "Offer convenient banking solutions and financial advice.",
    },
    {
      tabContent: [
        {
          heading: "Course information",
          content:
            "Get assistance with course details and help with the enrollment process to ensure a smooth start.",
          alt: "Course details and enrollment support",
        },
        {
          heading: "Assignment reminders",
          content:
            "Receive timely reminders about upcoming assignments and support for submitting your work successfully.",
          alt: "Assignment notification and guidance",
        },
        {
          heading: "Study resources",
          content:
            "Access a variety of study materials and quick quizzes to enhance your learning experience.",
          alt: "Learning materials and quizzes",
        },
      ],
      image: realWorldImage5,
      alt: "WhatsApp chatbot improves business engagement",
      subtitle: "Support learners and enhance educational experiences.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Freshworks",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the best WhatsApp chatbot solution, offering a comprehensive and user-friendly platform tailored for businesses of all sizes. With its advanced AI capabilities and intuitive interface, Pepper Cloud CRM enables seamless integration of WhatsApp into your customer engagement strategy, providing powerful automation and personalisation features to enhance your business communication.",
      img: compareItemImg1,
      alt: "Best WhatsApp chatbot user experience",
      features: [
        {
          title: "Automated customer support solutions",
          desc: "Implement AI-powered chatbots that comprehend natural language and deliver instant, precise responses to frequently asked customer inquiries.",
        },
        {
          title: "No-Code chatbot builder",
          desc: "Develop advanced chatbot workflows without requiring programming expertise through an intuitive drag-and-drop interface.",
        },
        {
          title: "Dynamic knowledge management",
          desc: "Maintain a current knowledge base to guarantee that your chatbot offers the most pertinent and accurate information.",
        },
        {
          title: "Insights and performance metrics",
          desc: "Acquire essential insights into customer engagements and chatbot effectiveness to continuously enhance your engagement strategy.",
        },
        {
          title: "Seamless human transition",
          desc: "Efficiently transfer complex inquiries to human representatives as necessary, ensuring a smooth customer experience.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot",
      desc: "HubSpot offers WhatsApp integration as part of its comprehensive CRM platform, making it suitable for businesses already using HubSpot's marketing tools. While not as specialised in WhatsApp chatbots as Pepper Cloud, it provides a solid option for companies looking for an all-in-one solution.",
      img: compareItemImg2,
      alt: "WhatsApp chatbot streamlines customer replies",
      features: [
        {
          title: "Conversation routing",
          desc: "Automatically route WhatsApp chats to the right team or representative.",
        },
        {
          title: "Chatbot templates",
          desc: "Use pre-built templates to quickly set up basic chatbot functionalities.",
        },
        {
          title: "Integration with other HubSpot tools",
          desc: "Seamlessly connect WhatsApp interactions with other marketing and sales features.",
        },
        {
          title: "Basic analytics",
          desc: "Track conversation metrics and team performance.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce provides WhatsApp Business integration through its Service Cloud, offering a robust solution for enterprise-level businesses. While powerful, it may be overly complex for smaller organisations.",
      img: compareItemImg3,
      alt: "Best solution for WhatsApp chatbot automation",
      features: [
        {
          title: "Omni-channel routing",
          desc: "Direct WhatsApp chats to the most appropriate agent or department.",
        },
        {
          title: "AI-powered chatbots",
          desc: "Create chatbots using Salesforce's Einstein AI technology.",
        },
        {
          title: "Customisable workflows",
          desc: "Design complex automation workflows for WhatsApp interactions.",
        },
        {
          title: "Extensive reporting",
          desc: "Generate detailed reports on WhatsApp engagement and performance.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers WhatsApp integration as part of its multichannel communication features. It provides a good balance of functionality and affordability, making it suitable for small to medium-sized businesses.",
      img: compareItemImg4,
      alt: "Seamless best WhatsApp chatbot integration",
      features: [
        {
          title: "WhatsApp template messages",
          desc: "Create and send approved template messages for marketing and support.",
        },
        {
          title: "Conversation tracking",
          desc: "Keep a record of all WhatsApp interactions within the CRM.",
        },
        {
          title: "Basic chatbot functionality",
          desc: "Set up simple automated responses and workflows.",
        },
        {
          title: "Mobile app access",
          desc: "Manage WhatsApp conversations on-the-go with Zoho's mobile app.",
        },
      ],
    },
    {
      title: "Freshworks",
      desc: "Freshworks CRM includes WhatsApp Business integration in its Freshchat module, offering a user-friendly solution for businesses looking to incorporate WhatsApp into their customer engagement strategy.",
      img: compareItemImg5,
      alt: "Interactive WhatsApp chatbot for businesses",
      features: [
        {
          title: "WhatsApp campaign management",
          desc: "Create and manage WhatsApp marketing campaigns.",
        },
        {
          title: "Chatbot builder",
          desc: "Design basic chatbots with a visual flow builder.",
        },
        {
          title: "Team inbox",
          desc: "Manage all WhatsApp conversations in a centralised team inbox.",
        },
        {
          title: "Performance analytics",
          desc: "Monitor key metrics for WhatsApp interactions and campaigns.",
        },
      ],
    },
  ];
  const adaptList = [
    {
      pointer: "Instant customer support",
      desc: "Provide round-the-clock assistance to your customers, answering queries and resolving issues in real-time, enhancing overall customer satisfaction.",
      img: salesImg1,
      alt: "Instant customer support",
    },
    {
      pointer: "Efficient lead generation",
      desc: "Capture and qualify leads automatically through engaging conversations, streamlining your sales funnel and boosting conversion rates.",
      img: salesImg2,
      alt: "Efficient lead generation",
    },
    {
      pointer: "Personalised marketing campaigns",
      desc: "Deliver tailored content and product recommendations to boost engagement and drive sales with messaging that matches individual preferences.",
      img: salesImg3,
      alt: "Personalised marketing campaigns",
    },
    {
      pointer: "Seamless order processing",
      desc: "Enable customers to place orders, track shipments, and manage returns through WhatsApp, simplifying the entire purchasing journey.",
      img: salesImg4,
      alt: "Seamless order processing",
    },
    {
      pointer: "Auto appointment scheduling",
      desc: "Allow customers to book, reschedule, or cancel appointments effortlessly, reducing no-shows and improving operational efficiency.",
      img: salesImg5,
      alt: "Auto appointment scheduling",
    },
    {
      pointer: "Valuable customer insights",
      desc: "Gather and analyse customer data and feedback through chatbot interactions, helping you refine your products and services.",
      img: salesImg6,
      alt: "Valuable customer insights",
    },
    {
      pointer: "Cost-effective operations",
      desc: "Reduce customer service costs by automating routine tasks and inquiries, allowing your team to focus on high-value activities.",
      img: salesImg7,
      alt: "Cost-effective operations",
    },
  ];
  return (
    <main>
      <SEO
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={
          "Best AI Powered WhatsApp Chatbot | Conversational AI | Pepper Cloud"
        }
        keywords="best WhatsApp chatbot,WhatsApp chatbot,best solution for WhatsApp chatbot"
        description={
          "Give 24X7 real-time constant customer support and experience 3X ROI using AI Driven WhatsApp Chatbot. Offers features like multiple device support, bulk messaging, and more."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
      />
      <section
        className={clsx(classes.SalesMangerSection, "sales-hero-section")}
      >
        <div className="container">
          <div className={classes.SalesMangerContainer}>
            <motion.div
              className={classes.heroContent}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <h1 className="font-wix-semibold font-64 ">
                Unleashing the power of the best WhatsApp chatbot software
              </h1>
              <p className="font-wix-regular font-18">
                Transform your customer engagement with Pepper Cloud
                cutting-edge WhatsApp chatbot. Elevate your business
                communication to new heights with our AI-powered solution.
              </p>
              <div className="buttonContainer">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </motion.div>
            <motion.div
              className={classes.bannerCards}
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "blueCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering3(true)}
                // onMouseLeave={() => !isMobile && setIsHovering3(false)}
              >
                <img src={bannerIcon3} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Seamless integration:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Seamlessly integrate WhatsApp into your sales and customer
                  service strategy.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "greenCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering4(true)}
                // onMouseLeave={() => !isMobile && setIsHovering4(false)}
              >
                <img src={bannerIcon2} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Smart automation:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Automate responses to common queries, freeing up your team for
                  complex tasks.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "regularCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering5(true)}
                // onMouseLeave={() => !isMobile && setIsHovering5(false)}
              >
                <img src={bannerIcon4} />
                <h3 className="font-wix-semibold font-20 font-white">
                  Scalable personalisation:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Personalise customer interactions at scale, enhancing
                  satisfaction and loyalty.
                </p>
              </div>
              <div
                className={clsx(
                  classes.cardContainer,
                  "bannerCard",
                  "purpleCard"
                )}
                // onMouseEnter={() => !isMobile && setIsHovering5(true)}
                // onMouseLeave={() => !isMobile && setIsHovering5(false)}
              >
                <img src={bannerIcon1} />
                <h3 className="font-wix-semibold font-20 font-white">
                  24/7 availability:
                </h3>
                <p className="font-wix-regular font-18 color-black7">
                  Drive sales and support with 24/7 availability on WhatsApp.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by sales team managers across industries
          </p>
          <Swiper
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              // For smaller screens (mobile)
              0: {
                slidesPerView: 2,
                freeMode: true,
                // grabCursor: false,
                spaceBetween: 40,
                slidesPerGroup: 1,
                // autoplay: false,
                // modules: [],
              },
              // For larger screens (desktop)
              768: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
              1200: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 40,
              },
            }}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            modules={[Autoplay]}
            speed={2500}
            slidesPerView={"auto"}
            // centeredSlides={true}
            spaceBetween={30}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className={classes.benifitSection}>
        {benifitList.map((benifit) => (
          <section className={classes.integrationSection}>
            <div className="container">
              <div className={classes.integrationHeader}>
                <div className={classes.integrationLeft}>
                  <motion.h2
                    className="font-wix-semibold font-56 color-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {benifit.title}
                  </motion.h2>
                  {benifit.points.map((pointer) => (
                    <motion.div
                      className={classes.benfitListItem}
                      initial={{ opacity: 0, y: 20 }}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                    >
                      <LazyImage
                        alt="WhatsApp chatbot boosts customer retention"
                        className={classes.benfitIcon}
                        source={bannerTick}
                      />
                      <div className={classes.benfitListItemContent}>
                        <p className="font-wix-semibold font-20 color-black1">
                          {pointer.heading}
                        </p>
                        <p className="font-wix-regular font-18 color-black2">
                          {pointer.content}
                        </p>
                      </div>
                    </motion.div>
                  ))}
                </div>
                <div className={classes.integrationRight}>
                  <img
                    alt="Best CRM for sales managers"
                    className={classes.integrationRightImage}
                    src={benifit.img}
                  />
                </div>
              </div>
            </div>
          </section>
        ))}
        <div className={classes.absoulteCard}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-48 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  What is a WhatsApp chatbot software?
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  A WhatsApp chatbot is an AI-powered automated messaging system
                  that operates within the WhatsApp platform. It enables
                  businesses to engage with customers instantly, handle queries,
                  process orders, and deliver personalised content, all through
                  the familiar WhatsApp interface.
                </motion.p>
              </div>
              <div className={classes.integrationRight}>
                <img
                  alt="Comprehensive best solution for WhatsApp chatbot"
                  className={classes.integrationRightImage}
                  src={cardImg2}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.experienceContainer} ref={ref}>
        <section className={classes.accordianTabs}>
          <div className="container">
            <div className="headercenterContainer">
              <motion.h2
                className="font-wix-semibold font-56 text-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Why Pepper Cloud CRM is best solution for WhatsApp chatbot
              </motion.h2>
            </div>
            <div className={classes.experienceInnerContainer}>
              <div className={classes.experienceContainerLeft}>
                {experienceList.map((faq, index) => (
                  <motion.div
                    key={index}
                    className={clsx(
                      classes.faqBoxAccordian,
                      activeAccordian === index && "active",
                      "text-color2"
                    )}
                    onClick={() => {
                      if (activeAccordian !== index) {
                        setActiveAccordian(index); // only switch if different
                      }
                    }}
                  >
                    <div
                      className={clsx(
                        classes.experienceHeader,
                        activeAccordian === index && "noClick"
                      )}
                    >
                      <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                      <img
                        alt="Arrow"
                        className={clsx(
                          classes.downArrow,
                          activeAccordian === index && "active"
                        )}
                        src={downArrow}
                      />
                    </div>

                    <Collapse
                      className={classes.body}
                      in={activeAccordian === index}
                    >
                      <p className="font-18 font-wix-regular color-black2 exp-desc">
                        {faq.desc}
                      </p>
                      {/* <a
                        className="font-18 font-wix-regular view-more-link"
                        href={faq.linkUrl}
                      >
                        {faq.lintText}{" "}
                        <img alt="Arrow Right" src={arrowRight} />{" "}
                      </a> */}
                      <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={faq.img}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    </Collapse>
                  </motion.div>
                ))}
              </div>
              <div className={classes.experienceContainerRight}>
                {experienceList.map(
                  (experience, index) =>
                    index === activeAccordian && (
                      <motion.img
                        initial={{ opacity: 1, y: 20 }}
                        src={experience.img}
                        alt={experience.alt}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      />
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="header-section">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Benefits of using WhatsApp chatbot
            </motion.h2>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1,
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              slidesPerGroup: 1,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: 15,
            },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold lineHeight-1">
                  {point.pointer}
                </p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section>
        <section className={classes.realWorldTabs}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Applications and use cases of WhatsApp chatbot
              </motion.h2>
              <div
                className={classes.tabsContainer}
                ref={sectionRef}
                style={{
                  display: "flex",
                  overflowX: "auto",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 0 && "active"
                  )}
                  onClick={() => setActiveRealWorld(0)}
                >
                  E-commerce and retail
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 1 && "active"
                  )}
                  onClick={() => setActiveRealWorld(1)}
                >
                  Healthcare
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 2 && "active"
                  )}
                  onClick={() => setActiveRealWorld(2)}
                >
                  Travel and hospitality
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 3 && "active"
                  )}
                  onClick={() => setActiveRealWorld(3)}
                >
                  Financial services
                </div>
                <div
                  className={clsx(
                    classes.tab,
                    "font-wix-semibold",
                    "font-20",
                    activeRealWorld === 4 && "active"
                  )}
                  onClick={() => setActiveRealWorld(4)}
                >
                  Education
                </div>
              </div>
            </div>

            <div className={classes.tabCard}>
              <div className={classes.tabCardLeftContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <div>
                        <motion.p
                          className="font-wix-regular font-18 color-black2"
                          initial={{ opacity: 0, y: 20 }}
                          transition={{ duration: 0.3 }}
                          whileInView={{ opacity: 1, y: 0 }}
                        >
                          {listItem.subtitle}
                        </motion.p>
                        <div className={classes.benfitListContainer}>
                          {listItem.tabContent.map((item) => (
                            <motion.div
                              className={classes.benfitListItem}
                              initial={{ opacity: 0, y: 20 }}
                              transition={{ duration: 0.3 }}
                              whileInView={{ opacity: 1, y: 0 }}
                            >
                              <LazyImage
                                alt={item.alt}
                                className={classes.benfitIcon}
                                source={bannerTick}
                              />
                              <div className={classes.benfitListItemContent}>
                                <p className="font-wix-semibold font-20 color-black1">
                                  {item.heading}
                                </p>
                                <p className="font-wix-regular font-18 color-black2">
                                  {item.content}
                                </p>
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    )
                )}
              </div>
              <div className={classes.tabCardRightContainer}>
                {tabContentData.map(
                  (listItem, index) =>
                    index === activeRealWorld && (
                      <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        // className={classes.aiSectionRight}
                      >
                        <LazyImage
                          alt={listItem.alt}
                          source={listItem.image}
                          width={"100%"}
                        />
                      </motion.div>
                    )
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 Best CRM with WhatsApp chatbot in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          faqs={faqs}
          heading={"Frequently asked questions on best WhatsApp chatbot (FAQs)"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              WhatsApp chatbot - Your 24/7 customer assistant: automate, engage,
              excel!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default aiWhatsappChatbot;
